module.exports = __webpack_public_path__ + "img/Bodice-Front-B9-Da-Ea-Fb.4f153feb.png";